<template>
  <aha-modal :title="category.value" @hide="$emit('hide')" size="3xl">
    <section class="correct-options">
      <div v-for="(option, index) in options(category)" :key="index" class="option">
        <span class="option-value">{{ option.value }}</span>
        <span class="option-stats" v-if="isShowCorrectAnswer">
          <Answer
            :numberOfCorrectAnswers="correctAnswerCountPerOption(category, option)"
            :numberOfIncorrectAnswers="incorrectAnswerCountPerOption(category, option)"
            :isShowUserIcon="false"
            :size="'xs'"
            class="w-fit"
          ></Answer>
        </span>
      </div>
    </section>
  </aha-modal>
</template>

<script>
import Answer from '@/components-v2/presentation-editor/middle/common/Answer.vue'

export default {
  components: {
    Answer,
  },
  props: {
    category: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    options: {
      type: Function,
      required: true,
    },
    isShowCorrectAnswer: {
      type: Boolean,
      default: false,
    },
    correctAnswerCountPerOption: {
      type: Function,
      default: () => {},
    },
    incorrectAnswerCountPerOption: {
      type: Function,
      default: () => {},
    },
  },
}

</script>

<style lang="scss" scoped>
    .correct-options {
        height: 293px;
        max-height: 293px;
        overflow-y: auto;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: repeat(3, 1fr);
        gap: 0.75rem;

        & > .option {
            padding: 0.75rem;
            border-radius: 0.5rem;
            border: 1px solid #D3D7E1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .option-value {
              margin-bottom: 8px;
            }
        }
    }
</style>
